import { Sparkles } from "lucide-react";
import { MARQUEE_ITEMS } from "@/content";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE_ITEMS.map((item) => (
      <span key={`${item}-${hidden}`} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-muted-foreground/80 sm:text-3xl">
          {item}
        </span>
        <Sparkles size={16} className="shrink-0 text-terra/70" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-border/50 bg-secondary/50 py-7"
  >
    <div className="flex w-max animate-marquee">
      <Row hidden={false} />
      <Row hidden={true} />
    </div>
  </section>
);
